import { useEffect, useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { Grid, Typography, Box, Stack, Skeleton } from '@mui/material';
import { AddCircleOutlineRounded } from '@mui/icons-material';
import {
  findAutorizacionesAmbulatorias,
  getAutorizacionAmbulatoria,
} from '../../services/Busquedas/Autorizaciones';
import {
  getComprobanteAutorizacion,
  getProvidenciaAutorizacion,
} from '../../services/Afiliado/Autorizaciones';
import { getReimprimirOrden } from '../../services/Seo/Orden';
import AnularAutorizacionPopUp from './AnularAutorizacionPopUp';
import EnviarAutorizacionPopUp from './EnviarAutorizacionPopUp';
import EnviarProvidenciaAutorizacionPopUp from './EnviarProvidenciaAutorizacionPopUp';
import CustomizedSnackbars from '../Notifications/SnackBar';
import { CODIGO_ESTADO_APROBADO } from './VerAutorizacion';
import { AutorizacionesItem } from './components/AutorizacionesItem';
import { LoadingButton } from '@mui/lab';
import { ButtonBackMobile } from '../Breadcrumb/ButtonBackMobile';
import { VideoModalMobile } from '../Common/VideoModalMobile';

export const AutorizacionesMobile = () => {
  const history = useHistory();
  const [autorizaciones, setAutorizaciones] = useState(null);
  const [autorizacion, setAutorizacion] = useState(null);
  const [onOpenAnular, setOpenAnular] = useState(null);
  const [onOpenEnviar, setOpenEnviar] = useState(null);
  const [onOpenEnviarProvidencia, setOpenEnviarProvidencia] = useState(null);
  const [success, setSuccess] = useState('');
  const [openedToggleId, setOpenedToggleId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (autorizaciones === null) {
      getInfo();
    }
  }, [autorizaciones]);

  const getInfo = async () => {
    setLoading(true);
    try {
      const response = await findAutorizacionesAmbulatorias();
      setAutorizaciones(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAnular = (autorizacion) => {
    setAutorizacion(autorizacion);
    setOpenAnular(true);
  };

  const handleEnviar = (autorizacion) => {
    setAutorizacion(autorizacion);
    setOpenEnviar(true);
  };

  const handleProvidenciaEnviar = (autorizacion) => {
    setAutorizacion(autorizacion);
    setOpenEnviarProvidencia(true);
  };

  const onHandlePreview = async (autorizacion) => {
    try {
      let urlPDF = null;
      if (autorizacion.codigoEstado === CODIGO_ESTADO_APROBADO) {
        urlPDF = await getProvidenciaAutorizacion({
          id: autorizacion.idSolicitudCobertura,
          enviarMail: false,
        });
      }
      const solicitud = await getAutorizacionAmbulatoria(autorizacion.idSolicitudCobertura);

      history.push('/ver-autorizacion', {
        from: history.location,
        autorizacion: {
          ...solicitud,
          practicas: autorizacion.practicasLabel,
          providenciaUrl: urlPDF,
        },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleAnulada = async (anulada) => {
    setAutorizacion(null);
    setOpenAnular(false);
    if (anulada) {
      getInfo();
    }
  };

  const handleEnviada = async (anulada) => {
    setSuccess('La solicitud de autorización ha sido enviada correctamente.');
    setAutorizacion(null);
    setOpenEnviar(false);
  };

  const handleProvidenciaEnviada = async (anulada) => {
    setSuccess('La providencia ha sido enviada correctamente');
    setAutorizacion(null);
    setOpenEnviarProvidencia(false);
  };

  const handleBorrarMensaje = () => {
    setSuccess('');
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          sx={{
            height: '32px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
          }}
        >
          <ButtonBackMobile />
          <VideoModalMobile
            src={'https://www.youtube.com/embed/WrZCCdfzaRI?si=SxYuBWRLYLQEfWwT&autoplay=1'}
          />
        </Box>
        <Typography gutterBottom variant='h5' component='h2'>
          Solicitudes de Autorización
        </Typography>
        <Typography variant='body2' color='textSecondary' component='p' align='justify'>
          Acá podrás consultar el estado de las solicitudes de autorización{' '}
          <b>solicitadas en los últimos 30 días</b>. Una vez iniciada, la auditoria del pedido{' '}
          <b>puede demorar hasta un máximo de 72 hs. hábiles</b>.
        </Typography>

        <LoadingButton
          sx={{ my: 3 }}
          component={RouterLink}
          to={'/agregar-autorizacion'}
          variant='contained'
          fullWidth
          color='primary'
          disableElevation
          startIcon={<AddCircleOutlineRounded />}
        >
          Nueva Solicitud
        </LoadingButton>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <Typography fontWeight={'bold'} variant='button'>
            Mis Solicitudes
          </Typography>

          {/* mostrar la cantidad de registros encontrados */}
          {loading ? (
            <Skeleton variant='text' width={130} height={20} />
          ) : (
            <Typography variant='caption'>
              <b>{autorizaciones?.length}</b> {autorizaciones?.length === 1 ? 'registro encontrado' : 'registros encontrados'}
            </Typography>
          )}  
        </Box>

        {!loading && !autorizaciones && (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            Sin solicitudes de autorizaciones ambulantes.
          </Stack>
        )}

        <Box
          sx={{
            my: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          {loading &&
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
              return (
                <Box
                  key={item}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#fff',
                    px: 1,
                    py: 2,
                    borderRadius: '8px',
                  }}
                >
                  <Skeleton variant='text' width={'100%'} height={28} />
                  <Skeleton variant='text' width={150} height={20} />
                  <Skeleton variant='text' width={150} height={20} />
                </Box>
              );
            })}
          {!loading && autorizaciones?.length > 0 &&
            autorizaciones.map((autorizacion) => (
              <AutorizacionesItem
                key={autorizacion.idSolicitudCobertura}
                autorizacion={{...autorizacion, id: autorizacion.idSolicitudCobertura}}
                isOpen={openedToggleId === autorizacion.idSolicitudCobertura}
                onToggleOpen={() => {
                  setOpenedToggleId(
                    openedToggleId === autorizacion.idSolicitudCobertura
                      ? null
                      : autorizacion.idSolicitudCobertura,
                  );
                }}
                onAnular={(e) => {
                  handleAnular(e);
                }}
                onEnviar={(e) => {
                  handleEnviar(e);
                }}
                onEnviarProvidencia={(e) => {
                  handleProvidenciaEnviar(e);
                }}
                onPreview={(e) => {
                  onHandlePreview(e);
                }}
              />
            ))}
        </Box>
      </Grid>

      {onOpenAnular ? (
        <AnularAutorizacionPopUp
          open={onOpenAnular}
          autorizacion={autorizacion}
          setAutorizacionAnulada={handleAnulada}
        />
      ) : null}
      {onOpenEnviar ? (
        <EnviarAutorizacionPopUp
          open={onOpenEnviar}
          autorizacion={autorizacion}
          setAutorizacion={handleEnviada}
          onCancelar={() => setOpenEnviar(false)}
        />
      ) : null}
      {onOpenEnviarProvidencia ? (
        <EnviarProvidenciaAutorizacionPopUp
          open={onOpenEnviarProvidencia}
          autorizacion={autorizacion}
          setAutorizacion={handleProvidenciaEnviada}
          onCancelar={() => setOpenEnviarProvidencia(false)}
        />
      ) : null}

      <CustomizedSnackbars
        open={success}
        autoHideDuration={8000}
        severity='success'
        message={success}
        onDeleteMessage={handleBorrarMensaje}
      />
    </Grid>
  );
};
